import { render, staticRenderFns } from "./Restaurants.vue?vue&type=template&id=6defc7e4&scoped=true"
import script from "./Restaurants.vue?vue&type=script&lang=js"
export * from "./Restaurants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6defc7e4",
  null
  
)

export default component.exports